import { jsxs, jsx } from "react/jsx-runtime";
const IconLinkSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M7.054 21.946a4.965 4.965 0 0 1-3.535-1.465c-.945-.943-1.465-2.199-1.465-3.535s.52-2.592 1.465-3.535l3.239-3.24a1 1 0 1 1 1.414 1.415l-3.24 3.24c-.566.566-.878 1.319-.878 2.12s.312 1.555.879 2.121c1.132 1.133 3.109 1.133 4.242 0l3.24-3.239a1 1 0 1 1 1.413 1.414l-3.24 3.24a4.964 4.964 0 0 1-3.534 1.464Zm9.481-7.825a1 1 0 0 1-.707-1.707l3.24-3.238a3.005 3.005 0 0 0 0-4.243 3.007 3.007 0 0 0-4.244 0l-3.238 3.239a1 1 0 1 1-1.414-1.414l3.238-3.24a5.006 5.006 0 0 1 7.071 0 5.008 5.008 0 0 1 0 7.072l-3.239 3.238a.997.997 0 0 1-.707.293Z" }),
      /* @__PURE__ */ jsx("path", { d: "M8.172 16.828a1 1 0 0 1-.707-1.707l7.656-7.656a1 1 0 1 1 1.414 1.414L8.88 16.535a.997.997 0 0 1-.707.293Z" })
    ]
  }
);
export {
  IconLinkSvg
};
